import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';

export const GET_YEARS_REQUEST = 'GET_YEARS_REQUEST';
export const GET_YEARS_SUCCESS = 'GET_YEARS_SUCCESS';
export const GET_YEARS_ERROR = 'GET_YEARS_ERROR';

export const CLEAN_YEARS = 'CLEAN_YEARS';

// Get years
export function getYears() {
    return async (dispatch) => {
        try {
            dispatch(getYearsRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.get('/api/stats/years', { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getYearsSuccess, getYearsError));
        } catch (err) {
            dispatch(utilsLib.response(err, getYearsError));
        }
    };
}
function getYearsRequest() {
    return {
        type: GET_YEARS_REQUEST,
        isFetching: true
    };
}
function getYearsSuccess (payload) {
    return {
        type: GET_YEARS_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getYearsError(errorMessage) {
    return {
        type: GET_YEARS_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Clean years reducer
export function cleanYears() {
    return {
        type: 'CLEAN_YEARS',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/years.js